<div class="govuk-grid-row">
  <div class="govuk-grid-column-three-quarters">
    <span class="govuk-caption-xl govuk-!-margin-bottom-2">{{ workplaceName }}</span>
    <h1 class="govuk-heading-l govuk-!-margin-bottom-8">
      Discounts from Skills for Care's endorsed training providers
    </h1>
    <app-details [title]="revealTitle">
      <p>
        These are the best learning and development providers within the adult social care sector who've gained a
        quality mark endorsement from Skills for Care.
      </p>
      <p>
        <a
          href="https://www.skillsforcare.org.uk/Learning-development/Endorsement/Skills-for-Care-Endorsement.aspx"
          target="_blank"
          >Read more about endorsed training providers</a
        >
        on the Skills for Care website.
      </p>
    </app-details>
    <div class="asc-cms-content" [innerHTML]="pages.content"></div>
  </div>
</div>
